export interface XandrSegment {
  id: number;
  active: boolean;
  name: string;
  description?: string;
}

export interface XandrBuyer {
  id: number;
  active: true;
  name: string;
  buyerId: number;
  costType: string;
  revSharePct: number
}

export interface XandrPricingDataCategory {
  id: number;
  name: string;
  active: boolean;
  priceCpm: number;
}

export interface XandrSegmentBilling {
  id: number;
  segmentId: number;
  active: boolean;
  public: boolean;
  dataCategoryId: number;
  dataSegmentTypeId: string;
  dataCategoryXandr: XandrPricingDataCategory;
}

export interface XandrSegmentBillingRequest {
  active: boolean;
  public: boolean;
  dataCategoryId: number;
  dataSegmentTypeId: string;
  dataCategoryXandr: XandrPricingDataCategory;
}

export interface XandrBuyerBilling {
  buyers: XandrBuyer[];
  publishers: XandrBuyer[];
  billing: XandrSegmentBillingRequest;
}

export interface XandrDataPriceCategoryBuyerCustomPrice {
  id: number;
  active: boolean;
  lastModified: string;
  buyerId: number;
  priceCategoryName: string;
  priceCategoryId: number;
  priceCpm: number;
  currencyCode: string;
}


export enum XandrBillingType {
  Unassigned = 'unassigned',

  Audience = 'Audience',

  BrandSafety = 'Brand Safety',

  FraudDetection = 'Fraud Detection',

  Viewability = 'Viewability',

  Contextual = 'Contextual',

  Geolocation = 'Geolocation',

  B2B = 'B2B',

  Purchase = 'Purchase',

  Interest = 'Interest',

  Demo = 'Demo',

  InMarket = 'In-Market'

}
